import React, { Component } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { hideModal, showModal } from "../../../../../../actions/modals";
import api from '../../../../../../api/index';
import validator from '../../../../../../services/DataValidator';
import { normalizeNumberMaxDecimals, renderError } from "../../../../../../services/helpers";
import Spiner from "../../../../../common/Spiner";

const typeRegister = [
    { value: 1, label: 'Кошти' },
    { value: 2, label: 'Літри' },
];

class CompanyModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            ID: '',
            address: '',
            closed: false,
            name: '',
            limit: 10,
            payType: '',
            typePaymentList: [
                { value: 1, label: 'Відомість Д' },
                { value: 0, label: 'Готівковий розрахунок' },
            ],
            selectedTypeRegister: null,
            selectedTypeTerm: null,
            callback: () => { },
            validation: []
        };
    }

    componentDidMount() {
        if (typeof this.props.propsData !== 'undefined') {
            const data = this.props.propsData;

            this.setState({
                ID: data.ID,
                address: data.Address,
                closed: data.Closed,
                name: data.Name,
                limit: data.Limit === null ? '' : data.Limit,
                payType: !data.TypePayment ? '' : {
                    value: data.TypePayment.ID,
                    label: data.TypePayment.PaymentName,
                },
                selectedTypeRegister: !data.TypeRegister ? null : {
                    value: data.TypeRegister.ID,
                    label: data.TypeRegister.RegisterName
                },
                selectedTypeTerm: !data.TypeTerm ? null : {
                    value: data.TypeTerm.ID,
                    label: data.TypeTerm.TermName,
                },
                callback: data.callback,
            });
        }
    }

    handleInputChange = (event) => {
        const target = event.target;
        let value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        if (event.target.dataset.type === 'number') {
            value = normalizeNumberMaxDecimals(value, 9999999999999, 7);
        }

        this.setState({ [name]: value });
    };

    handleChangePayType = (selectedOption) => {
        this.setState({ payType: selectedOption });
    };

    handleTypeRegister = (selectedOption) => {
        this.setState({ selectedTypeRegister: selectedOption });
    };

    handleTypeTerm = (selectedOption) => {
        this.setState({ selectedTypeTerm: selectedOption });
    };

    handleSave = () => {
        let validationResult = validator.arrayValidation([
            { id: 'name', name: 'Назва', type: 'EMPTY', value: this.state.name },
            { id: 'address', name: 'Адреса', type: 'EMPTY', value: this.state.address },
            { id: 'payType', name: 'Форма оплати', type: 'EMPTY', value: this.state.payType }
        ]);

        if (validationResult.state === 'success') {
            this.setState({ loading: true });
            const ID = this.state.ID;
            const dataToSend = {
                ID: this.state.ID,
                Address: this.state.address,
                Closed: this.state.closed,
                Name: this.state.name,
                Limit: !(+this.state.limit) ? null : +this.state.limit,
                TypeRegisterID: this.state.selectedTypeRegister ? +this.state.selectedTypeRegister.value : null,
                TypeTermID: this.state.selectedTypeTerm == null ? null : +this.state.selectedTypeTerm.value,
                TypePaymentID: +this.state.payType.value,
            };

            api.apiEditCompany(dataToSend, ID).then(res => {
                this.setState({ loading: false });
                if (res.status === 204) {
                    this.props.dispatchHideModal();
                    this.props.dispatchShowModal('INFO_MODAL', { title: 'Редагувати компанію', description: 'Компанія була успішно відредагована', type: true });
                    this.state.callback();
                } else {
                    this.props.dispatchHideModal();
                    this.props.dispatchShowModal('INFO_MODAL', { title: 'Редагувати компанію', description: 'Компанія не була відредагована. Зверніться до адміністратора', type: false });
                }
            }).catch(error => {
                this.setState({ loading: false });
                this.props.dispatchHideModal();
                this.props.dispatchShowModal('INFO_MODAL', { title: 'Редагувати компанію', description: error.response.data.message, type: false });
            });
        }

        this.setState({ validation: validationResult.errorArr });
    };

    render() {
        return (
            <div>
                <div className="modal-header">
                    <button type="button" className="close" onClick={this.props.closeModal}>
                        <i className="fa fa-times"></i>
                    </button>
                    <h5 className="modal-title">Редагувати компанію</h5>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="modal__row">
                                <h5>Назва</h5>
                                <div className="form-group">
                                    <input
                                        placeholder="Введіть назву"
                                        type="text"
                                        className="form-control"
                                        name="name"
                                        value={this.state.name}
                                        onChange={this.handleInputChange} />
                                    <div className="form-group-error">
                                        {renderError('name', this.state.validation)}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12">
                            <div className="modal__row">
                                <h5>Адреса</h5>
                                <div className="form-group">
                                    <input
                                        placeholder="Введіть адресу"
                                        type="text"
                                        className="form-control"
                                        name="address"
                                        value={this.state.address}
                                        onChange={this.handleInputChange} />
                                    <div className="form-group-error">
                                        {renderError('address', this.state.validation)}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12">
                            <div className="modal__row">
                                <h5>Тип обліку</h5>
                                <div className="checkbox">
                                    <Select
                                        value={this.state.selectedTypeRegister}
                                        onChange={this.handleTypeRegister}
                                        options={typeRegister} />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12">
                            <div className="modal__row">
                                <h5>Кількість ліміту</h5>
                                <div className="form-group">
                                    <input
                                        placeholder="Введіть кількість ліміту"
                                        type="text"
                                        className="form-control"
                                        name="limit"
                                        data-type="number"
                                        value={this.state.limit}
                                        onChange={this.handleInputChange} />
                                    <div className="form-group-error">
                                        {renderError('limit', this.state.validation)}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12">
                            <div className="modal__row">
                                <h5>Термін ліміту</h5>
                                <div className="checkbox">
                                    <Select
                                        placeholder="Виберіть термін ліміту"
                                        value={this.state.selectedTypeTerm}
                                        onChange={this.handleTypeTerm}
                                        options={this.props.typeTerm}
                                        isClearable />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12">
                            <div className="modal__row">
                                <h5>Форма оплати</h5>
                                <Select
                                    placeholder="Виберіть форму оплати"
                                    value={this.state.payType}
                                    onChange={this.handleChangePayType}
                                    options={this.state.typePaymentList} />
                            </div>
                            <div className="form-group-error">
                                {renderError('payType', this.state.validation)}
                            </div>
                        </div>
                        <div className="col-lg-12">
                            <div className="modal__row">
                                <h5>Заблоковано</h5>
                                <div className="checkbox">
                                    <label>
                                        <input
                                            type="checkbox"
                                            name="closed"
                                            checked={this.state.closed}
                                            onChange={this.handleInputChange} />
                                        <div className="form-group-error">
                                            {renderError('closed', this.state.validation)}
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-footer">
                    <div className="row">
                        <div className="col-lg-12">
                            <button
                                disabled={this.state.loading}
                                onClick={this.handleSave}
                                type="button"
                                className="btn btn-primary">
                                {
                                    !this.state.loading
                                        ? <span>Зберегти</span>
                                        : <span>Зберігаємо</span>
                                }
                                {!this.state.loading ? null : <Spiner />}
                            </button>
                            <button onClick={this.props.closeModal} type="button" className="btn btn-secondary">Відмінити</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    typeTerm: typeof state.user.data.typeTermList !== 'undefined' ? state.user.data.typeTermList : []
});

const mapDispatchToProps = (dispatch) => ({
    dispatchShowModal: (type, data) => dispatch(showModal(type, data)),
    dispatchHideModal: (type, data) => dispatch(hideModal(type, data))
});

export default connect(mapStateToProps, mapDispatchToProps)(CompanyModal);
